<% var component = new Anvil.models.components.GeoCoords(field) %>
<% if ('inline' in field && field.inline) { %>
<div anvil-component="<%- component.id %>" class="col<%- ('width' in field) ? `-${field.width}` : '' %>">
	<div class="input-group">
		<span class="input-group-text px-2">Lat</span>
		<input type="number" class="form-control" placeholder="szél." id="<%= form.name %>_<%= field.name %>_lat" name="<%= field.name %>_lat" value="<%= form.data[field.name] ? form.data[field.name][0] : '' %>" />
		<span class="input-group-text px-2">Lon</span>
		<input type="number" class="form-control" placeholder="hossz." id="<%= form.name %>_<%= field.name %>_lon" name="<%= field.name %>_lon" value="<%= form.data[field.name] ? form.data[field.name][1] : '' %>" />
	</div>
</div>
<% } else { %>
<div anvil-component="<%- component.id %>" class="form-group row">
	<div class="col-<%= ('label_width' in form.params) ? form.params.label_width : '4' %>">
		<label for="<%= form.name %>_<%= field.name %>" class="control-label"><%= field.title %></label>
	</div>
	<div class="col">
		<div class="input-group">
			<span class="input-group-text px-2"><image src="./assets/lat.png" /></span>
			<input type="number" class="form-control" placeholder="szél." id="<%= form.name %>_<%= field.name %>_lat" name="<%= field.name %>_lat" value="<%= form.data[field.name] ? form.data[field.name][0] : '' %>" />
			<span class="input-group-text px-2"><image src="./assets/lon.png" /></span>
			<input type="number" class="form-control" placeholder="hossz." id="<%= form.name %>_<%= field.name %>_lon" name="<%= field.name %>_lon" value="<%= form.data[field.name] ? form.data[field.name][1] : '' %>" />
		</div>
		<% if ('help' in field) { %><small class="form-text text-muted"><%- field.help %></small><% } %>
		<div class="invalid-feedback"></div>
	</div>
</div>
<% } %>
